module.exports = __webpack_public_path__ + "db4d76891e5089d1351a67f641f988e5.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/icons/build/fonts/spark-icon-line.ttf?
// module id = 1405
// module chunks = 0